// See https://www.npmjs.com/package/panzoom
import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  ViewChild,
} from "@angular/core";
import createPanZoom, { PanZoom } from "panzoom";

@Component({
  selector: "ngx-panzoom",
  template: "<div #content><ng-content></ng-content></div>",
  standalone: true,
})
export class PanZoomComponent implements AfterViewInit, OnDestroy {
  @ViewChild("content", { static: false }) content: ElementRef;
  private instance: PanZoom;

  ngAfterViewInit() {
    if (this.content) {
      this.instance = createPanZoom(this.content.nativeElement);
    }
  }

  ngOnDestroy() {
    this.instance?.dispose();
  }
}
